import React from 'react';

import energyIcon from 'assets/pics/energy_icon.svg';
import gasIcon from 'assets/pics/gas_icon.svg';
import { useNEFISteps } from 'context/NEFIStepsContext';
import { useFormik } from 'formik';

import { FormActionButtons } from 'components/FormHelper/FormActionButtons';
import { InputRow } from 'components/FormHelper/InputRow';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';
import {
  NEFI_CURRENT_TEST_SUITE,
  shouldFillNEFITestData,
} from 'components/NEFIForm/NEFITestdata/NEFITestSetup';
import { YNEFIBranchSelectionValidation } from 'components/NEFIValidation/NEFIBranchSelectionValidation';

import { NE_ACTIVE_STEP, TENANT_ID } from 'global/constants';

import { FFormDebug } from 'utils/FFormDebug';
import { getTenantId } from 'utils/tenantUtil';

import './NEFIStepBranchSelection.sass';

export const NEFIStepBranchSelection = () => {
  const {
    activeStep,
    setActiveStep,
    setSubmittedValuesWithStep,
    getSubmittedValuesWithStep,
    clearSubmittedValuesWithStep,
  } = useNEFISteps();
  const formik = useFormik({
    initialValues: shouldFillNEFITestData
      ? NEFI_CURRENT_TEST_SUITE.step1
      : {
          isEnergyActive: false,
          isGasActive: false,
        },
    validationSchema: YNEFIBranchSelectionValidation,
    validateOnMount: true,
    enableReinitialize: true,
    validateOnChange: true,
  });

  if (activeStep !== NE_ACTIVE_STEP.BRANCH_SELECTION) return null;

  const onBack = () => {
    setActiveStep(NE_ACTIVE_STEP.EMAIL_INPUT);
  };

  const onSubmit = () => {
    const currentContextValues = getSubmittedValuesWithStep(NE_ACTIVE_STEP.BRANCH_SELECTION);
    const { values } = formik;
    const valuesChanged = Object.keys(values).some(
      (key) => values[key] !== currentContextValues[key]
    );

    if (valuesChanged) {
      clearSubmittedValuesWithStep(NE_ACTIVE_STEP.FORM);
      setSubmittedValuesWithStep(NE_ACTIVE_STEP.BRANCH_SELECTION, formik.values);
    }

    setActiveStep(NE_ACTIVE_STEP.FORM);
  };

  const getErrorMessage = () => formik.errors.noBranchSelected || '';

  return (
    <>
      <div className="nefi-step-branch-selection">
        <div className="nefi-step-branch-selection-hero">Bitte wählen Sie Ihre Sparte(n) aus:</div>
        <InputRow>
          <LabelCheckbox
            label="Strom"
            id="isEnergyActive"
            name="isEnergyActive"
            error={Boolean(formik.errors?.noBranchSelected)}
            icon={energyIcon}
            value={formik.values.isEnergyActive}
            onChange={formik.handleChange}
          />
          {getTenantId() !== TENANT_ID.LVN && (
            <LabelCheckbox
              label="Gas"
              id="isGasActive"
              name="isGasActive"
              error={Boolean(formik.errors?.noBranchSelected)}
              icon={gasIcon}
              value={formik.values.isGasActive}
              onChange={formik.handleChange}
            />
          )}
        </InputRow>
      </div>
      <FFormDebug values={formik.values} errors={formik.errors} />
      <div className="nefi-form__action-buttons">
        <FormActionButtons
          hasErrors={Object.keys(formik.errors).length > 0}
          titleLeft="Zurück"
          titleRight={activeStep === NE_ACTIVE_STEP.FORM_UPLOAD ? 'Antrag einreichen' : 'Weiter'}
          onClickLeft={onBack}
          onClickRight={onSubmit}
          errorMessage={getErrorMessage()}
        />
      </div>
    </>
  );
};
